import React, { ReactElement } from 'react';
import { ComponentProps as Props } from './Logo.types';
import StyledSVG from './Logo.styled';

const WordLogo: React.FC<Props> = ({ variant, ...props }): ReactElement<Props> => (
  <StyledSVG xmlns="http://www.w3.org/2000/svg" width="448" viewBox="0 0 448 82" variant={variant} {...props}>
    <g clip-path="url(#clip0_564_8648)">
      <path
        className="text"
        d="M75.09 27.46H57.74V80.86H75.09V27.46ZM0 80.86H51.39V64.17H18.31V11.25H0V80.86ZM77.61 10.77C77.61 4.38 73.13 0 66.55 0C59.97 0 55.59 4.39 55.59 10.77C55.59 17.15 60.07 21.45 66.55 21.45C73.03 21.45 77.61 17.06 77.61 10.77ZM118.63 80.85L139.7 27.45H122.06L112.05 55.1L109.57 63.68L107.28 55.1L97.55 27.45H79.62L100.12 80.85H118.62H118.63ZM153.78 49.29C154.92 42.61 159.02 38.99 165.7 38.99C173.04 38.99 176.28 43.19 176.66 49.29H153.78ZM153.59 57.78H193.45V52.63C193.45 38.9 184.96 26.41 166.08 26.41C147.2 26.41 137.09 39.09 137.09 54.63C137.09 70.17 146.43 81.8 165.79 81.8C179.43 81.8 187.63 75.79 192.11 66.93L177.23 61.4C174.75 66.45 171.7 68.55 166.08 68.55C158.64 68.55 154.45 64.83 153.59 57.78V57.78ZM263.16 80.86H280.42V11.25H255.25L240.66 62.83L239.9 66.83L239.23 62.73L225.02 11.24H199.28V80.86H216.63V32.8L216.15 23.65L218.34 33.28L231.97 80.86H247.61L261.44 33.18L263.54 23.45L263.16 32.79V80.85V80.86ZM327.87 54.16C327.87 62.84 324.63 68.27 316.43 68.27C308.23 68.27 304.89 62.93 304.99 54.16C304.99 45.39 308.52 39.67 316.43 39.67C324.34 39.67 327.87 45.2 327.87 54.16ZM345.7 54.16C345.7 38.52 335.69 26.41 316.43 26.41C297.17 26.41 287.16 38.33 287.16 54.25C287.16 70.17 296.89 81.81 316.43 81.81C335.97 81.81 345.7 69.8 345.7 54.16V54.16ZM387.33 44.05L391.53 28.13C389.43 27.18 386.76 26.7 383.33 26.7C375.03 26.7 370.93 31.37 368.74 42.24V27.46H351.58V80.86H368.84V55.5C368.84 46.73 373.42 42.25 379.04 42.25C382.47 42.25 384.95 42.92 387.34 44.06L387.33 44.05ZM407.51 49.3C408.65 42.62 412.75 39 419.43 39C426.77 39 430.01 43.2 430.4 49.3H407.52H407.51ZM407.32 57.79H447.18V52.64C447.18 38.91 438.69 26.42 419.82 26.42C400.95 26.42 390.83 39.1 390.83 54.64C390.83 70.18 400.17 81.81 419.53 81.81C433.17 81.81 441.37 75.8 445.85 66.94L430.98 61.41C428.5 66.46 425.45 68.56 419.82 68.56C412.38 68.56 408.19 64.84 407.33 57.79"
        fill="#4140A4"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_8648">
        <rect width="447.16" height="81.81" fill="white" />
      </clipPath>
    </defs>
  </StyledSVG>
);

const PictureLogo: React.FC<Props> = ({ variant, width, ...props }): ReactElement<Props> => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '99'}
    viewBox="0 0 99 99"
    variant={variant}
    {...props}>
    <g clip-path="url(#clip0_564_8606)">
      <path
        className="house"
        d="M21.5077 47.7131C21.5473 47.7131 21.5869 47.7131 21.6265 47.7131C28.8782 47.7477 35.2934 51.2226 39.6791 57.4943C40.6493 58.8803 41.5156 60.39 42.2828 62.0235C46.921 52.5789 52.1878 44.5995 57.8852 38.4566C63.9391 31.9325 70.3939 27.621 76.7546 25.7499L52.069 1.04942C50.6681 -0.351433 48.401 -0.351433 47.0002 1.04942L1.11863 46.9607C0.455333 47.624 0.0791328 48.5199 0.0692328 49.4555C0.0692328 49.5396 0.0345828 52.6631 0.00488281 57.6725C6.33593 51.3117 14.0381 47.7032 21.5077 47.7032"
        fill="#1CCBD7"
      />
      <path
        className="house"
        d="M85.4024 37.6844C80.3039 36.8577 73.7105 40.3326 67.3151 47.223C61.6176 53.366 53.3363 65.147 46.2726 86.3627L33.7343 84.4173C33.5264 69.5376 28.9723 60.6326 21.5572 60.593H21.488C10.1772 60.593 0.67815 75.3242 0 87.9121C0.01485 90.3079 0.0396 92.7185 0.06435 95.1193C0.0594 95.2133 0.05445 95.3123 0.05445 95.4064C0.05445 97.3864 1.65825 98.9951 3.63825 98.9951H95.4162C97.3962 98.9951 99 97.3913 99 95.4064V67.3992C98.2427 50.4158 93.0749 38.9219 85.4024 37.6794"
        fill="#1CCBD7"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_8606">
        <rect width="99" height="99" fill="white" />
      </clipPath>
    </defs>
  </StyledSVG>
);

const Logo: React.FC<Props> = ({
  mode = 'primary',
  variant = 'light',
  width,
  height,
  ...props
}): ReactElement<Props> => {
  const showWordLogo = mode === 'primary' || mode === 'secondary';
  const showPictureLogo = mode === 'primary' || mode === 'tertiary';

  const getSpacing = () => {
    if (mode === 'tertiary') {
      return '0';
    }
    return width ? (width / 24).toString() : '10';
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
      {showWordLogo && <WordLogo width={width} variant={variant} {...props} />}
      {showPictureLogo && (
        <PictureLogo
          width={width * (99 / 448)}
          variant={variant}
          {...props}
          style={{ marginLeft: `${getSpacing()}px` }}
        />
      )}
    </div>
  );
};

export default Logo;
